/**
 * Sibling Swap – AJAX colorway navigation
 *
 * Intercepts clicks on sibling product swatch links and replaces the
 * main-product section via Shopify's Section Rendering API, avoiding
 * a full page reload.
 */
(function () {
  var SWATCH_LINK = '.variant-picker a[href]';

  document.addEventListener('click', function (e) {
    var link = e.target.closest(SWATCH_LINK);
    if (!link) return;

    // Skip if this swatch is already the active product (checked radio)
    var radio = link.closest('li')?.querySelector('input[type="radio"]:checked');
    if (radio) {
      e.preventDefault();
      return;
    }

    var productUrl = link.getAttribute('href');
    if (!productUrl) return;

    // Walk up to the shopify-section wrapper
    var section = link.closest('.shopify-section');
    if (!section || !section.id) return;

    var sectionId = section.id.replace('shopify-section-', '');
    if (!sectionId) return;

    e.preventDefault();

    // Visual loading feedback
    section.style.opacity = '0.5';
    section.style.transition = 'opacity 0.15s ease';

    var separator = productUrl.indexOf('?') === -1 ? '?' : '&';
    var fetchUrl = productUrl + separator + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl)
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
        if (!fresh) throw new Error('Empty section');

        // Strip entrance-animation attributes so content appears instantly
        fresh.querySelectorAll('[data-animate]').forEach(function (el) {
          el.removeAttribute('data-animate');
        });

        // Swap innerHTML and re-execute <script> tags
        if (typeof theme !== 'undefined' && theme.HTMLUpdateUtility && theme.HTMLUpdateUtility.setInnerHTML) {
          theme.HTMLUpdateUtility.setInnerHTML(section, fresh.innerHTML);
        } else {
          section.innerHTML = fresh.innerHTML;
          section.querySelectorAll('script').forEach(function (old) {
            var s = document.createElement('script');
            Array.from(old.attributes).forEach(function (a) { s.setAttribute(a.name, a.value); });
            s.textContent = old.textContent;
            old.parentNode.replaceChild(s, old);
          });
        }

        section.style.opacity = '';
        history.pushState({ siblingSwap: true }, '', productUrl);
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function (err) {
        console.error('[sibling-swap]', err);
        section.style.opacity = '';
        window.location.href = productUrl;
      });
  });

  // Reload on back / forward so the full page state is correct
  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.siblingSwap) {
      location.reload();
    }
  });
})();
